




































































































import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import SubscriptionSignup from "@/store/modules/SubscriptionSignup";
import { bus } from "@/main";
import { getPromotionsByCode } from "@/helpers/api";
import terms from "@/components/terms.vue";
import privacy from "@/components/privacy.vue";

interface State {
  store: SubscriptionSignup;
  termsChecked: boolean;
}

export default Vue.extend({
  name: "TermsAndPrivacy",
  components: {
    terms,
    privacy
  },
  data(): State {
    return {
      store: getModule(SubscriptionSignup, this.$store),
      termsChecked: false
    };
  },
  methods: {
    setTermsChecked(e: any) {
      this.termsChecked = e;
    }
  },
  watch: {
    termsChecked: {
      handler: function(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.store.setTermsChecked(newVal);
          console.log(this.store.termsChecked);
        }
      },
      immediate: true
    }
  }
});
